import React from "react";
import moment from "moment";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  CountrycodeSelect,
  TailwindToaster,
  RichTextEditor,
} from "../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import Select from "react-select";
import Multiselect from "multiselect-react-dropdown";

import axios from "../../api/axios";

const MeetingsEdit = () => {
  const state = useSelector((state) => state.UserReducer);
  const { meetingId } = useParams();
  const meetingUrl = "/meetings/" + meetingId;
  const createUrl = "/meetings";
  const activeCRMUrl = "/user/active";
  const conflictCheckUrl = "/meetings/conflict";
  const navigate = useNavigate();

  const [recurring, setRecurring] = React.useState(false);

  const [notesTakerId, setNotesTakerId] = React.useState(null);
  const onNotesTakerChange = (selectedItem) => {
    setNotesTakerId(selectedItem.value);
  };

  const [timeKeeperId, setTimeKeeperId] = React.useState(null);
  const onTimeKeeperChange = (selectedItem) => {
    setTimeKeeperId(selectedItem.value);
  };

  const from_time_threshold = moment().format("yyyy-MM-DDTHH:mm");
  const [till_time_threshold, setTillTimeThreshold] = React.useState(
    moment(from_time_threshold).add(0.5, "hours").format("yyyy-MM-DDTHH:mm"),
  );

  const [attendeesSelected, setAttendeesSelectedData] = React.useState([]);
  const [attendeesIds, setAttendeesIds] = React.useState([]);
  const [conflictMeetings, setConflictMeetings] = React.useState([]);
  const [currentAttendeeSelected, setCurrentAttendee] = React.useState("");

  const addAttendee = (selectedItem) => {
    setAttendeesIds((oldArray) => [...oldArray, selectedItem.value]);

    // console.log(newAttendeeOptions);
  };

  const removeAttendee = (removedAttendee) => {
    const revisedAttendees = attendeesIds.filter((item) => {
      return item !== removedAttendee;
    });
    setAttendeesIds(revisedAttendees);
  };

  React.useEffect(() => {
    // console.log(attendeesIds);
    const newAttendees = crmData.filter((item) => {
      return attendeesIds.includes(item.value);
    });
    newAttendees.map((item) => {
      let count = 0;
      conflictMeetings.map((meetingItem) => {
        const isAttendee = meetingItem.attendeesRequired.filter(
          (attendeeItem) => {
            return (
              attendeeItem.user._id === item.value &&
              ["Accepted", "Not Responded"].includes(attendeeItem.response)
            );
          },
        );
        count += isAttendee.length;
      });
      item.conflictCount = count;
    });
    setAttendeesSelectedData(newAttendees);
    const newAttendeeOptions = crmData.filter((item) => {
      return !attendeesIds.includes(item.value);
    });
    setAttendeeOptions(newAttendeeOptions);
  }, [attendeesIds, conflictMeetings]);

  const updateTillTimeThreshold = (from_time) => {
    setTillTimeThreshold(
      moment(from_time).add(0.5, "hours").format("yyyy-MM-DDTHH:mm"),
    );
  };

  const [attendeesServerData, setAttendeesServerData] = React.useState([]);
  const [crmData, setCRMData] = React.useState([]);
  const [attendeeOptions, setAttendeeOptions] = React.useState([]);

  const getCRMOptions = () => {
    try {
      axios
        .get(activeCRMUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.users?.length > 0) {
            const crmOptionsData = [];
            response?.data?.users.map((item) => {
              const recordTuple = {
                value: item._id,
                label:
                  (item.fullname
                    ? item.fullname
                    : item.firstname +
                      (item.lastname ? " " + item.lastname : "")) +
                  (item.phone ? " | " + item.phone : "") +
                  (item.email ? " | " + item.email : ""),
                fullname: item.fullname
                  ? item.fullname
                  : item.firstname + (item.lastname ? " " + item.lastname : ""),
                email: item.email,
              };
              crmOptionsData.push(recordTuple);
            });
            setCRMData(crmOptionsData);
            setAttendeeOptions(crmOptionsData);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [agendahtml, setAgendaHtml] = React.useState("");

  const [attendeesRequiredArr, setAttendeesRequiredArr] = React.useState([]);

  React.useEffect(() => {
    const tempAttendeesArr = [];
    attendeesIds.map((item) => {
      const tempAttendeeItem = {
        user: item,
        response: "Not Responded",
      };
      tempAttendeesArr.push(tempAttendeeItem);
    });
    setAttendeesRequiredArr(tempAttendeesArr);
  }, [attendeesIds]);

  const [state_recurring_till_date, setStateRecurringTillDate] = React.useState(
    moment().format("yyyy-MM-DD"),
  );
  const [stFromTime, setStFromTime] = React.useState(
    moment().format("yyyy-MM-DDTHH:mm"),
  );
  const [stTillTime, setStTillTime] = React.useState(
    moment().format("yyyy-MM-DDTHH:mm"),
  );

  const [from_time, setFromTime] = React.useState(null);
  const [till_time, setTillTime] = React.useState(null);

  const conflictChecker = () => {
    if (from_time !== null && till_time !== null) {
      try {
        axios
          .post(
            conflictCheckUrl,
            JSON.stringify({
              excludeMeetingId: meetingId,
              attendeesIds,
              new_from_time: from_time,
              new_till_time: till_time,
            }),
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: state.user.token,
              },
            },
          )
          .then((response) => {
            if (response?.data?.status === "success") {
              setConflictMeetings(response.data.conflictingMeets);
            } else {
              toast.error(response.data.message);
            }
          })
          .catch((err) => {
            toast.error(err.message);
          });
      } catch (err) {
        console.log(err);
        toast.error(err.message);
      } finally {
        //
      }
    }
  };
  React.useEffect(() => {
    conflictChecker();
  }, [attendeesIds, from_time, till_time]);

  const handleSubmit = (event) => {
    var canSubmit = true;
    const meetingData = new FormData(event.target);
    const dataToSubmit = {
      from_time: meetingData.get("from_time"),
      till_time: meetingData.get("till_time"),
      recurring: recurring,
      recurring_till_date: meetingData.get("recurring_till"),
      notesTaker: notesTakerId,
      timeKeeper: timeKeeperId,
      topic: meetingData.get("topic"),
      agenda: agendahtml,
      attendeesRequired: attendeesRequiredArr,
    };

    try {
      axios
        .put(meetingUrl, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            setTimeout(() => {
              window.scrollTo(0, 0);
              navigate(-1);
            }, 1000);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      //
    }
  };

  const [meetingInfoRefresh, setMeetingInfoRefresh] = React.useState(false);
  const [meetingServerData, setMeetingServerData] = React.useState({});

  const getMeetingInfo = (meetingId) => {
    setMeetingInfoRefresh(true);
    try {
      axios
        .get(meetingUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.meeting) {
            setMeetingServerData(response.data.meeting);
            // console.log(response.data.meeting);
            setNotesTakerId(response.data.meeting.notesTaker._id);
            setTimeKeeperId(response.data.meeting.timeKeeper._id);
            if (response.data.meeting.attendeesRequired.length > 0) {
              const tempAttendees = [];
              response.data.meeting.attendeesRequired.map((item) => {
                tempAttendees.push(item.user._id);
              });
              setAttendeesIds(tempAttendees);
            }
            setRecurring(response.data.meeting.recurring);
            setStateRecurringTillDate(
              moment(response.data.meeting.recurring_till_date).format(
                "yyyy-MM-DD",
              ),
            );
            setStFromTime(
              moment(response.data.meeting.from_time).format(
                "yyyy-MM-DDTHH:mm",
              ),
            );
            setStTillTime(
              moment(response.data.meeting.till_time).format(
                "yyyy-MM-DDTHH:mm",
              ),
            );
            setFromTime(
              moment(response.data.meeting.from_time).format(
                "yyyy-MM-DDTHH:mm",
              ),
            );
            setTillTime(
              moment(response.data.meeting.till_time).format(
                "yyyy-MM-DDTHH:mm",
              ),
            );
          }
          setMeetingInfoRefresh(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
          setMeetingInfoRefresh(false);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      setMeetingInfoRefresh(false);
    }
  };

  // React.useEffect(() => {
  //   const attendeesServerIds = [];
  //   attendeesServerData.map((item) => {
  //     attendeesServerIds.push(item.user._id);
  //   });
  //   if (attendeesServerIds.length > 0) {
  //     const filteredAttendees = crmData.filter((item) => {
  //       return (
  //         attendeesServerIds.length > 0 &&
  //         attendeesServerIds.includes(item.value)
  //       );
  //     });
  //     setAttendeesSelectedData(filteredAttendees);
  //   }
  // }, [crmData, attendeesServerData]);

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getCRMOptions();
    getMeetingInfo();
  }, []);

  return (
    <>
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <form
                  action='#'
                  method='POST'
                  noValidate
                  onSubmit={(event) => {
                    event.preventDefault();
                    handleSubmit(event);
                  }}>
                  <TailwindToaster />
                  <div className='shadow overflow-hidden sm:rounded-sm'>
                    <div className='px-4 py-5 bg-gray-50 sm:p-6'>
                      <div className='lg:flex lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                            Edit Meeting
                          </h2>
                        </div>
                      </div>
                      <div className='mt-4 sm:mt-4 grid grid-cols-12 gap-3'>
                        <div className='col-span-9'>
                          <label
                            htmlFor='topic'
                            className={`block text-sm font-medium ${
                              !true ? "text-red-600" : "text-gray-700"
                            }`}>
                            Discussion Topic *
                          </label>
                          <input
                            type='text'
                            name='topic'
                            id='topic'
                            maxLength='1000'
                            defaultValue={meetingServerData.topic}
                            onBlur={(e) => {
                              // checkforExistingMeetings(e.target.value);
                              // For Meeting Number
                            }}
                            className={`mt-1  ${
                              !true
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            } block w-full shadow-sm sm:text-sm rounded-sm`}
                          />
                          {!true && (
                            <p className='text-red-600 text-sm'>
                              Topic invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-3'>
                          <label
                            htmlFor='location'
                            className={`block text-sm font-medium ${
                              !true ? "text-red-600" : "text-gray-700"
                            }`}>
                            Location *
                          </label>
                          <input
                            type='text'
                            name='location'
                            id='location'
                            maxLength='100'
                            defaultValue={meetingServerData.location}
                            onChange={(e) => {
                              if (e.target.value.length === 10) {
                                // checkforExistingMeetings(e.target.value);
                              }
                            }}
                            className={`mt-1  ${
                              !true
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            } block w-full shadow-sm sm:text-sm rounded-sm`}
                          />
                          {!true && (
                            <p className='text-red-600 text-sm'>
                              Location invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-4'>
                          <label
                            htmlFor='attendees'
                            className={`block text-sm font-medium ${
                              !true ? "text-red-600" : "text-gray-700"
                            }`}>
                            Attendees *
                          </label>
                          {attendeesSelected.length > 0 && (
                            <div className='flex flex-wrap pb-2 overflow-scroll '>
                              {attendeesSelected.map((item) => (
                                <div className='mr-2 mt-2 flex flex-no-wrap text-xs border-2 bg-yellow-100 text-yellow-dark  border-yellow-100 duration-300 hover:bg-yellow-2 hover:border-yellow-2 hover:text-white font-medium rounded-sm'>
                                  <div
                                    className='py-0.5 px-1 text-sm cursor-default'
                                    key={item.value}>
                                    {item.fullname}
                                  </div>
                                  {item.conflictCount > 0 && (
                                    <div className='py-0.5 pt-1 cursor-default'>
                                      <span className='bg-red-800 text-red-100 text-xs font-semibold ml-2 px-1 py-0.5 rounded-sm '>
                                        {item.conflictCount} Conflicts
                                      </span>
                                    </div>
                                  )}
                                  <div
                                    className='py-1 font-semibold px-1.5 hover:font-extrabold duration-300 text-red-800 cursor-pointer'
                                    onClick={() => {
                                      removeAttendee(item.value);
                                    }}>
                                    X
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}

                          <Select
                            className={`mt-1 text-sm block w-full bg-white rounded-md shadow-sm `}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary: "#f2b818",
                                primary50: "#f2b818",
                              },
                            })}
                            styles={{
                              control: (styles, state) => ({
                                ...styles,
                                border: !state.isFocused && "1px solid #6b7280",
                              }),
                              placeholder: (styles) => ({
                                ...styles,
                                color: "#6b7280",
                              }),
                              option: (baseStyles, data) => ({
                                ...baseStyles,
                                backgroundColor: "#fff",
                                fontSize: "9pt",
                                color: "#000",
                                ":active": {
                                  ...baseStyles[":active"],
                                  backgroundColor: "#f2b818",
                                },
                                "&:hover": {
                                  backgroundColor: "#fcf2d4",
                                },
                              }),
                            }}
                            onChange={addAttendee}
                            value={currentAttendeeSelected}
                            isSearchable={true}
                            options={attendeeOptions}
                            placeholder={"Select"}
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='from_time'
                            className='block text-sm font-medium text-gray-700'>
                            Start Time *
                          </label>
                          <input
                            type='datetime-local'
                            name='from_time'
                            id='from_time'
                            value={stFromTime}
                            min={from_time_threshold}
                            onChange={(event) => {
                              updateTillTimeThreshold(event.target.value);
                              setStFromTime(
                                moment(event.target.value).format(
                                  "yyyy-MM-DDTHH:mm",
                                ),
                              );
                              setFromTime(event.target.value);
                            }}
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='till_time'
                            className='block text-sm font-medium text-gray-700'>
                            End Time *
                          </label>
                          <input
                            type='datetime-local'
                            name='till_time'
                            id='till_time'
                            value={stTillTime}
                            min={till_time_threshold}
                            onChange={(event) => {
                              setStTillTime(
                                moment(event.target.value).format(
                                  "yyyy-MM-DDTHH:mm",
                                ),
                              );
                              setTillTime(event.target.value);
                            }}
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-4 sm:col-span-1'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Recurring *
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer'
                                checked={recurring}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setRecurring(!recurring);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-8 sm:col-span-2 ${
                            recurring
                              ? "opacity-100 pointer-events-auto"
                              : "opacity-40 pointer-events-none"
                          } duration-300`}>
                          <label
                            htmlFor='recurring_till'
                            className='block text-sm font-medium text-gray-700'>
                            Recurring Till
                          </label>
                          <input
                            type='date'
                            name='recurring_till'
                            id='recurring_till'
                            value={state_recurring_till_date}
                            onChange={(event) => {
                              setStateRecurringTillDate(
                                moment(event.target.value).format("yyyy-MM-DD"),
                              );
                            }}
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='notesTaker'
                            className='block text-sm font-medium text-gray-700'>
                            Notes Taker *
                          </label>
                          <Select
                            className={`mt-1 text-sm block w-full bg-white rounded-md shadow-sm `}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary: "#f2b818",
                                primary50: "#f2b818",
                              },
                            })}
                            styles={{
                              control: (styles, state) => ({
                                ...styles,
                                border: !state.isFocused && "1px solid #6b7280",
                              }),
                              placeholder: (styles) => ({
                                ...styles,
                                color: "#6b7280",
                              }),
                              option: (baseStyles, data) => ({
                                ...baseStyles,
                                backgroundColor: "#fff",
                                fontSize: "9pt",
                                color: "#000",
                                ":active": {
                                  ...baseStyles[":active"],
                                  backgroundColor: "#f2b818",
                                },
                                "&:hover": {
                                  backgroundColor: "#fcf2d4",
                                },
                              }),
                            }}
                            value={crmData.filter(function (option) {
                              return option.value === notesTakerId;
                            })}
                            onChange={onNotesTakerChange}
                            isSearchable={true}
                            options={crmData}
                            placeholder={"Select"}
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='timeKeeper'
                            className='block text-sm font-medium text-gray-700'>
                            Time Keeper *
                          </label>
                          <Select
                            className={`mt-1 text-sm block w-full bg-white rounded-md shadow-sm `}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary: "#f2b818",
                                primary50: "#f2b818",
                              },
                            })}
                            styles={{
                              control: (styles, state) => ({
                                ...styles,
                                border: !state.isFocused && "1px solid #6b7280",
                              }),
                              placeholder: (styles) => ({
                                ...styles,
                                color: "#6b7280",
                              }),
                              option: (baseStyles, data) => ({
                                ...baseStyles,
                                backgroundColor: "#fff",
                                fontSize: "9pt",
                                color: "#000",
                                ":active": {
                                  ...baseStyles[":active"],
                                  backgroundColor: "#f2b818",
                                },
                                "&:hover": {
                                  backgroundColor: "#fcf2d4",
                                },
                              }),
                            }}
                            value={crmData.filter(function (option) {
                              return option.value === timeKeeperId;
                            })}
                            onChange={onTimeKeeperChange}
                            isSearchable={true}
                            options={crmData}
                            placeholder={"Select"}
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-7 z-0'>
                          <label
                            htmlFor='notesTaker'
                            className='block text-sm font-medium text-gray-700'>
                            Agenda *
                          </label>
                          <RichTextEditor
                            setContent={setAgendaHtml}
                            initialValue={meetingServerData.agenda}
                          />
                        </div>
                      </div>
                      <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                        <div className='lg:flex lg:items-center justify-between'>
                          <div className='flex-1 min-w-0 px-0 lg:px-0'>
                            <Link
                              to='#'
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(-1);
                              }}
                              className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm
                        font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2
                        focus:ring-offset-2 focus:ring-yellow-2'>
                              Back
                            </Link>
                            <button
                              id='submitBtn'
                              type='submit'
                              className='ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className='sm: py-2'></div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default MeetingsEdit;
